module.exports = __webpack_public_path__ + "img/play-icon.522256fa.svg";